import { Input, InputProps, forwardRef } from "@chakra-ui/react";

const LoginLayoutInput = forwardRef<InputProps, "input">((props, ref) => (
  <Input ref={ref} bg="rgba(255,255,255,.85)" {...props} />
));

export default LoginLayoutInput;
